
export const GetCustomerUsers = (api, custId) => {
    return api.get("/api/v1/User/GetCustomerUsers?customerId=" + custId);
}

export const GetUserRoles = (api) => {
    return api.get("/api/v1/User/GetUserRoles");
}

export const AddUser = (api, user) => {
    return api.post("/api/v1/User/AddUser", user)
}

export const EditUser = (api, user) => {
    return api.post("/api/v1/User/EditUser", user)
}

export const SetUserIsActiveValue = (api, value, userId) => {
    return api.get("/api/v1/User/SetUserIsActiveValue?value=" + value + "&userId=" + userId);
}

export const ChangePassword = (api, userId, passwords) => {
    return api.post("/api/v1/User/ChangePassword?userId=" + userId, passwords)
}

export const SendResetPasswordToUser = (api, userId) => {
    return api.get("/api/v1/User/sendResetPasswordToUser?userId=" + userId)
}

export const GetCustomerInfo = (api, custId) => {
    return api.get(`/api/v1/User/GetCustomerInfo?custId=${custId}`)
}

export const UpdateUserMarketing = (api, marketing, email, sms, phone) => {
    return api.post(`/api/v1/User/updateUserMarketing?marketing=${marketing}&email=${email}&sms=${sms}&phone=${phone}`, null)
}

export const GetCustomerUsersWithoutEHandelAcces = (api, custId) => {
    return api.get(`/api/v1/User/getCustomerUsersWithoutEHandelAcces?custId=${custId}`)
}

export const DeleteUserWithoutEHandelAcces = (api, recNo, custId, contactNumber, userCode, userLogin) => {
    return api.delete(`/api/v1/User/deleteUserWithoutEHandelAcces?recNo=${recNo}&custId=${custId}&contactNumber=${contactNumber}&userCode=${userCode}&userLogin=${userLogin}`)
}

export const AddCustomerUserWithoutEHandelAcces = (api, customerUser) => {
    return api.post(`/api/v1/User/addCustomerUserWithoutEHandelAcces`, customerUser)
}

export const EditCustomerUserWithoutEHandelAcces = (api, customerUser) => {
    return api.post(`/api/v1/User/editCustomerUserWithoutEHandelAcces`, customerUser)
}

